document.addEventListener('DOMContentLoaded', function () {
  // 1. Select the element you want to move
  var mediaQuery = window.matchMedia('(min-width: 1024px)');
  var elementToMove = document.querySelector('#article_wrapper');
  var targetContainer = document.querySelector('#left_col');
  var originalContainer = document.querySelector('right_col');

  function handleViewportChange(e) {
    if (e.matches) {
      // Viewport is over 1024px: move to destination
      targetContainer.append(elementToMove);
    } else {
      // Viewport is 1024px or less: return to original spot
      originalContainer.append(elementToMove);
    }
  }

  if (elementToMove) {
    // 1. Run on initial load
    handleViewportChange(mediaQuery); // 2. Register listener for future changes

    mediaQuery.addEventListener('change', handleViewportChange);
  }
}); // Create a media query list object